var _defs, _g, _circle, _line, _line2, _circle2, _line3, _line4, _circle3, _line5, _line6, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendbabeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 180",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vb-chrome",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vb-chrome-dark",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#888888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vb-highlight",
    x1: "0%",
    y1: "0%",
    x2: "60%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#ffffff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vb-brand",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5B8CFF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A855F7",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "vb-sparkle",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#ffffff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vb-glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5B8CFF",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vb-glow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "18,22 50,22 82,130 114,22 90,22 82,46",
    fill: "url(#vb-chrome-dark)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14,18 52,18 82,124 112,18 146,18 82,168 14,18",
    fill: "url(#vb-chrome)",
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14,18 52,18 82,124 112,18 146,18 82,168 14,18",
    fill: "url(#vb-highlight)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 18,
    x2: 82,
    y2: 138,
    stroke: "rgba(255,255,255,0.5)",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 18,
    x2: 82,
    y2: 138,
    stroke: "rgba(160,160,160,0.4)",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152,16 160,44 190,44 166,62 174,90 152,74 130,90 138,62 114,44 144,44",
    fill: "url(#vb-chrome-dark)",
    opacity: 0.5,
    transform: "translate(2,2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152,16 160,44 190,44 166,62 174,90 152,74 130,90 138,62 114,44 144,44",
    fill: "url(#vb-chrome)",
    stroke: "rgba(255,255,255,0.35)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152,16 160,44 190,44 166,62 174,90 152,74 130,90 138,62 114,44 144,44",
    fill: "url(#vb-highlight)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 16,
    x2: 152,
    y2: 74,
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 44,
    x2: 174,
    y2: 90,
    stroke: "rgba(200,200,200,0.25)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 44,
    x2: 130,
    y2: 90,
    stroke: "rgba(200,200,200,0.25)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14,18 52,18 82,124 112,18 146,18 82,168 14,18",
    fill: "url(#vb-brand)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152,16 160,44 190,44 166,62 174,90 152,74 130,90 138,62 114,44 144,44",
    fill: "url(#vb-brand)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 14,
    r: 5,
    fill: "url(#vb-sparkle)",
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 6,
    x2: 152,
    y2: 22,
    stroke: "white",
    strokeWidth: 0.6,
    opacity: 0.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: 14,
    x2: 160,
    y2: 14,
    stroke: "white",
    strokeWidth: 0.6,
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 16,
    r: 4,
    fill: "url(#vb-sparkle)",
    opacity: 0.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 14,
    y2: 22,
    stroke: "white",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 20,
    y2: 16,
    stroke: "white",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 44,
    r: 3.5,
    fill: "url(#vb-sparkle)",
    opacity: 0.65
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 192,
    y1: 38,
    x2: 192,
    y2: 50,
    stroke: "white",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 186,
    y1: 44,
    x2: 198,
    y2: 44,
    stroke: "white",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 170,
    r: 3,
    fill: "url(#vb-sparkle)",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendbabeeIcon);
export default __webpack_public_path__ + "static/media/vendbabee-icon.7a3865cf3d3c6ab26a8ebbeaf85ee1c9.svg";
export { ForwardRef as ReactComponent };